var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('choose-category'),(_vm.currentModel)?_c('choose-model'):_vm._e(),(_vm.currentModel)?_c('choose-height'):_vm._e(),(_vm.currentModel)?_c('choose-frame-color'):_vm._e(),(_vm.currentModel)?_c('choose-logo-color'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }